import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoTecnologia from "./CreaEquipo/CreaEquipoTecnologia";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

function EquipoTecnologia({ idSolicitud }) {
  const cookies = new Cookies();

  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const nombreRuta = window.location.hash.replace("#", "");

  const obtenerLista = () => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTecnologiaPorSolicitudId?SolicitudId=${idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((res) => setList(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    obtenerLista();
  }, [idSolicitud]);

  const eliminarEquipo = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "No podrás revertir esta acción",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      axios
        .delete(
          `https://suadesarrollo.azurewebsites.net/api/eliminarEquipoTecnologiaPorId?Id=${id}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
            data: {
              tipoAccion: "Eliminación de registro en equipo tecnología",
              idUsuario: cookies.get("id"),
            },
          },
        )
        .then(() => {
          Swal.fire("Eliminado", "Registro eliminado correctamente", "success");
          obtenerLista();
        })
        .catch(() =>
          Swal.fire("Error", "No se pudo eliminar el registro", "error"),
        );
    });
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const currentItems = list.slice(
    indexOfLastItem - itemsPerPage,
    indexOfLastItem,
  );

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Equipo Autoevaluación de Gestión de Tecnología
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta.includes("ProcesoAutoevaluacion") && (
              <CreaEquipoTecnologia
                idSolicitud={idSolicitud}
                onCreated={obtenerLista}
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Área</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  <th>Antiguedad</th>
                  <th>SolicitudId</th>
                  {cookies.get("tipo_Usuario") == 2 &&
                    nombreRuta.includes("ProcesoAutoevaluacion") && (
                      <th>Acción</th>
                    )}
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.area}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>
                      <td>{item.antiguedad}</td>
                      <td>{item.solicitudId}</td>
                      {cookies.get("tipo_Usuario") == 2 &&
                      nombreRuta.includes("ProcesoAutoevaluacion") ? (
                        <td className="text-center">
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarEquipo(item.id)}
                          >
                            Eliminar
                          </button>
                        </td>
                      ) : null}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No hay registros disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <ul className="pagination">
            {list.length > itemsPerPage &&
              Array.from(
                { length: Math.ceil(list.length / itemsPerPage) },
                (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ),
              )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EquipoTecnologia;
